import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';
import { BRAND } from '../brand';
import { useTheme } from '../theme/ThemeProvider';
import { ApiError } from '../lib/api';

export function ForgotPassword() {
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not send reset email.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="mx-auto max-w-sm">
      <img
        src={theme === 'dark' ? BRAND.logoSrc : BRAND.logoOriginal}
        alt={BRAND.name}
        className="mx-auto mb-6 w-full max-w-xs"
      />
      <h1 className="mb-2 text-center font-display text-3xl text-cream-50">Forgot password</h1>
      <p className="mb-6 text-center text-sm text-cream-300/70">
        Enter your email and we&apos;ll send a link to choose a new password.
      </p>
      {sent ? (
        <div className="card space-y-4 text-sm text-cream-200">
          <p>If an active account exists for that address, a reset link is on its way. Check your inbox.</p>
          <Link to="/login" className="btn-ghost inline-block text-gold-200">
            Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="card space-y-4">
          {error && (
            <p className="rounded border border-wine-500/50 bg-wine-900/40 px-3 py-2 text-sm text-wine-100">
              {error}
            </p>
          )}
          <div>
            <label className="mb-1 block text-xs uppercase tracking-wide text-cream-300/70">Email</label>
            <input
              type="email"
              className="field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
          <Link to="/login" className="btn-ghost block w-full text-center text-sm">
            Back to sign in
          </Link>
        </form>
      )}
    </div>
  );
}
